module.exports = __webpack_public_path__ + "static/media/load-icon.9a925def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Images/load-icon.svg
// module id = 549
// module chunks = 2